module.exports = __webpack_public_path__ + "img/flux_ferme.01c44965.jpg";